import { useSelector } from "react-redux";
import { selectModalOne } from "../../store/espacoCentenarioSlice";
import { TextContent } from "../../components/TextContent";

const ModalCentenario = () => {
    const [data] = useSelector(selectModalOne);
    return <TextContent {...data}/> 
} ;
export default ModalCentenario;